import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Notification } from './notification.interface';
// import { NotificationService } from './notification.service';
// const service = new NotificationService();

export interface NotificationState {
   notifications: Array<Notification>;
   notificationHistory: Array<Notification>;
}

const NotificationStore: Module<NotificationState, StoreState> = {
   namespaced: true,
   state: {
      notifications: [],
      notificationHistory: [],
   },
   getters: {},
   mutations: {
      ADD_NOTIFICATION(state, notification: Notification) {
         state.notifications.push(notification);
         state.notificationHistory.push(notification);
      },
      REMOVE_NOTIFICATION(state, notification: Notification) {
         const index = state.notifications.findIndex((n) => n.key === notification.key);
         state.notifications.splice(index, 1);
      },
      SET_NOTIFICATIONS(state, notifications: Array<Notification>) {
         state.notifications = notifications;
      },
      SET_NOTIFICATION_HISTORY(state, notifications: Array<Notification>) {
         state.notificationHistory = notifications;
      },
   },
   actions: {},
};

export default NotificationStore;
